import { Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { IDetalheHistoricoMercadoria } from "../../../../../../types/api/estoque/detalhe-historico-mercadoria";


export default function CardDivergencias({
    data
}: CardDivergenciasProps) {
    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" component="h2" gutterBottom>Divergências</Typography>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Produto na NF</b></TableCell>
                                <TableCell><b>Motivo</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.itens.map((produto, index: number) => (
                                <TableRow key={produto.nf_item_id} sx={{ '& td': { minHeight: '60px', height: '60px' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell>
                                        <Typography variant="caption">
                                            {produto.nf_produto}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="caption">
                                            {produto.motivo ?? 'Sem motivo'}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    )
}

export interface CardDivergenciasProps {
    data: IDetalheHistoricoMercadoria;
}
